export enum UploadType {
  INVOICE = 'INVOICE',
  RECOVERY = 'RECOVERY',
  UPLOAD = 'UPLOAD',
}
